<template>
  <div v-if="items.length" class="roles">
    <h2 v-if="showTitle" class="roles__title">{{ $t('getInTouch') }}</h2>

    <div class="roles__list">
      <div class="roles__item" v-for="(item, index) in items" :key="index">
        <div class="roles__item-top">
          <div class="roles__avatar" :style="{ backgroundImage: `url(${item.avatar})` }"></div>
        </div>
        <div class="roles__item-bottom">
          <h3 class="roles__name">{{ item.name }}</h3>
          <div
            class="roles__user-title"
            v-for="(title, index) in (item.title || '').split(',')"
            :key="index + 'title'"
          >
            {{ title }}
          </div>

          <a v-if="item.phone" class="roles__phone" :href="`tel:${item.phone}`">{{ item.phone }}</a>
          <a v-if="item.email" class="roles__email" :href="`mailto:${item.email}`">{{
            item.email
          }}</a>

          <div class="roles__company">
            <img
              v-if="showCompanyLogo(item)"
              class="roles__company-logo"
              :src="item.company.logo"
              :alt="item.company.name"
            />
            <span v-if="showCompany(item)" class="roles__company-name">
              {{ item.company.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    showTitle: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    items() {
      return this.$path('data.content') || []
    },
  },
  methods: {
    showCompanyLogo(contact) {
      if (!contact.company && !(this.$path('contact.company.logo.url') || '').includes('avatar'))
        return false
      return Boolean(contact.company.logo)
    },
    showCompany(contact) {
      if (!contact.company) return false
      return Boolean(contact.company.name)
    },
  },
}
</script>

<style lang="scss">
.roles {
  color: black;
  a {
    color: black;
  }

  &__title {
    margin-bottom: 0.8rem;
  }
  &__avatar {
    $size: clamp(90px, 180px, 200px);
    height: $size;
    width: $size;
    background-size: cover;
    background-position: center;
    flex-shrink: 0;
  }
  &__list {
    display: flex;

    flex-direction: column;
    gap: 3rem;
  }

  &__name {
    margin-bottom: 0.3rem;
  }

  &__user-title {
    font-size: 0.8rem;
    text-transform: uppercase;
    color: $dark-grey;
  }

  &__item {
    display: flex;
    gap: 1rem;
    flex-direction: column;

    &-bottom {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  &__email,
  &__phone {
    white-space: nowrap;
  }

  &__company {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &-name {
      opacity: 0.5;
    }
    &-logo {
      max-width: 5rem;
    }
  }
}
</style>
